export default {
  name: 'PersonalArea'
}
